import React, { Component } from 'react'
import I18n from "i18n-js";
import '../../translations.js';

export default class ShowTable extends Component {
  constructor(props) {
    super(props)
    this.showDuration = this.showDuration.bind(this);
    this.avblStallUnits = this.avblStallUnits.bind(this);
    this.avblCampsiteUnits = this.avblCampsiteUnits.bind(this);
    this.avblNumber = this.avblNumber.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
  }

  dateString(date) {
    //I18n.l(Date.today, :format => '%d %B %Y');
    //return this.monthName(date.getMonth()) + " " + ("0" + date.getDate()).slice(-2) + ", " + date.getFullYear()
    if (I18n.locale === "fr")
      return I18n.strftime(date, "%d %B %Y");
    else
      return I18n.strftime(date, "%B %d, %Y");
  }

  dateIncrement(date, days) {
    return new Date(date.getTime() + 1000*60*60*24*days)
  }

  showDuration() {
    var tz_date = new Date(this.props.startDate);
    var tz_offset = tz_date.getTimezoneOffset() * 60000;
    var date = new Date(tz_date.getTime() + tz_offset);
    date = this.dateIncrement(date, this.props.daysBefore * (-1))
    const totalDays = this.props.daysBefore + this.props.showDays + this.props.daysAfter;
    return totalDays + I18n.t("rts.services.starting_from") + this.dateString(date);
  }

  valueAsOption(value) {
    return <option key={value} value={value}>{value}</option>
  }

  avblStallUnits() {
    var stalls = this.props.stallsAvailable,
    stalls_show_type = this.props.stallShowType,
    avbl_units = 0
    if (stalls_show_type) {
      avbl_units = stalls.find(stalls => { return stalls.id == stalls_show_type }).avbl_show_units
      return avbl_units < 0 ? Number(this.props.value) : avbl_units + Number(this.props.value)
    } else {
      return false
    }
  }

  avblCampsiteUnits() {
    var campsites = this.props.campsitesAvailable,
    campsites_show_type = this.props.campsiteShowType,
    avbl_units = 0
    if (campsites_show_type) {
      avbl_units = campsites.find(campsites => { return campsites.id == campsites_show_type }).avbl_show_units
      return avbl_units < 0 ? Number(this.props.value) : avbl_units + Number(this.props.value)
    } else {
      return false
    }
  }

  isDisabled() {
    if (this.props.secretary) {
      return false;
    }
    if (this.props.assignments) {
      return true
    }
    if (this.props.tabId == "stalls") {
      return this.avblStallUnits() == 0
    } else if (this.props.tabId == "campsites") {
      return this.avblCampsiteUnits() == 0
    }
  }

  avblNumber() {
    var avbl = 0
    if (this.props.tabId == "stalls") {
      avbl = this.avblStallUnits() + 1;
    } else if (this.props.tabId == "campsites") {
      avbl = this.avblCampsiteUnits() + 1;
    }

    return avbl
  }

  render() {
    const show_value = this.props.value;
    var start_amt = 0;
    const amt_size = 101;
    if (this.props.assignments) {
      start_amt = this.props.assignments.split(',').length;
    }
    if (!this.props.editable) {
      start_amt = show_value;
    }
    var avbl = this.avblNumber()
    var numbers = new Array(amt_size).fill(start_amt, start_amt, avbl);
    return (
      <table className="table">
        <thead>
          <tr>
            <th>{I18n.t("rts.services.show_duration")}</th>
            <th>{I18n.t("rts.services.qty")}</th>
            <th>{I18n.t("rts.services.assignments")}</th>
          </tr>
        </thead>
        <tbody>
          <tr className="show-day">
            <td>{this.showDuration()}</td>
            <td>
              <select className="input-mini input-mini-90" id={`${this.props.tabId}ShowReservations`} disabled={this.isDisabled()} value={this.props.value} onChange={this.props.onChange}>
                { numbers.map((x, index) => this.valueAsOption(index)) }
              </select>
            </td>
            <td>
              <label>{this.props.assignments}</label>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}
